Pegasus.BackgroundColorBoxView = Ember.View.extend({
  color: '',
  attributeBindings: ['style'],
  style: function(){
    return 'background:' + this.get('color') + ';';
  }.property('color'),
  classNames: ['color-defaults'],
  isInvalid: false,
  classNameBindings: ['colorSelected'],
  template: Ember.Handlebars.compile('<div class="box"></div>'),
  colorSelected: function(){
    return this.get('controller.selectedBackgroundColor') === this.get('color');
  }.property('controller.selectedBackgroundColor'),
  click: function(){
    this.set('controller.selectedBackgroundColor', this.get('color'));
  }
});

Pegasus.BodyBackgroundColorBoxView = Ember.View.extend({
  color: '',
  invalidColor: function(){
    return !this.isValidSelection( this.get('color') );
  }.property('color'),
  isValidSelection: function(hex){
    if ( ! this.get('controller.footerLabelColor') && ! this.get('controller.footerAnchorColor') ) { return true; }

    return colorsDistance( hex, this.get('controller.footerLabelColor') ) > 15 &&
      colorsDistance( hex, this.get('controller.footerAnchorColor') ) > 15;
  },
  attributeBindings: ['style'],
  style: function(){
    return 'background:' + this.get('color') + ';';
  }.property('color'),
  classNames: ['color-defaults'],
  classNameBindings: ['colorSelected', 'invalidColor:unselectable', 'isEmpty:empty'],
  isEmpty: function(){
    return this.get('color') === 'transparent';
  }.property('color'),
  template: Ember.Handlebars.compile('<div class="box"></div>'),
  colorSelected: function(){
    return this.get('controller.selectedBackgroundColor') === this.get('color');
  }.property('controller.selectedBackgroundColor'),
  click: function(){
    if ( this.get('invalidColor') ) {
      return;
    }
    var toolbarController = Pegasus.lookupController('toolbar');
    toolbarController.set('selectedBackgroundColor', this.get('color'));
    toolbarController.get('userSelectedColors').addObject( this.get('color').toUpperCase() );
  }
});

Pegasus.ThemeRowBoxView = Pegasus.BackgroundColorBoxView.extend({
  colorSelected: function(){
    return this.get('controller.selectedRowColor') === this.get('color');
  }.property('controller.selectedRowColor'),
  click: function(){
    var toolbarController = Pegasus.lookupController('toolbar');
    toolbarController.get('userSelectedColors').addObject( this.get('color').toUpperCase() );

    this.get('controller').set('selectedRowColor', this.get('color'));
  }
});

Pegasus.BlockRegionColorBoxView = Pegasus.BackgroundColorBoxView.extend({
  colorSelected: function(){
    return this.get('controller.selectedBlockRegionColor') === this.get('color');
  }.property('controller.selectedBlockRegionColor'),
  click: function(){
    var toolbarController = Pegasus.lookupController('toolbar');
    toolbarController.get('userSelectedColors').addObject( this.get('color').toUpperCase() );

    this.get('controller').set('selectedBlockRegionColor', this.get('color'));
  }
});

Pegasus.RowColorBoxView = Pegasus.BackgroundColorBoxView.extend({
  colorSelected: function(){
    return this.get('controller.dataRowColor') === this.get('color');
  }.property('controller.dataRowColor'),
  click: function(){
    var toolbarController = Pegasus.lookupController('toolbar');
    toolbarController.get('userSelectedColors').addObject( this.get('color').toUpperCase() );

    this.get('controller').setProperties({
      dataRowColor: this.get('color')
    });

    return false;
  }
});

Pegasus.WhiteBoxView = Pegasus.BackgroundColorBoxView.extend({
  color: '#FFFFFF',
  classNames: ['white']
});

Pegasus.RedBoxView = Pegasus.BackgroundColorBoxView.extend({
  color: '#e7e7e7',
  classNames: ['grey']
});

Pegasus.BlueBoxView = Pegasus.BackgroundColorBoxView.extend({
  color: '#b6d7a8',
  classNames: ['green']
});

Pegasus.GreenBoxView = Pegasus.BackgroundColorBoxView.extend({
  color: '#cfe2f3',
  classNames: ['blue']
});

Pegasus.BlackBoxView = Pegasus.BackgroundColorBoxView.extend({
  color: '#ffe599',
  classNames: ['yellow']
});

Pegasus.GreyBoxView = Pegasus.BackgroundColorBoxView.extend({
  color: '#ead1dc',
  classNames: ['pink']
});

Pegasus.PatternView = Pegasus.BackgroundColorBoxView.extend({
  pattern: null,
  classNames: ['pattern'],
  classNameBindings: ['patternSelected'],
  attributeBindings: ['style'],
  style: function(){
    return 'background-image: url(' + this.get('pattern') + ');';
  }.property('pattern'),
  patternSelected: function(){
    return this.get('controller.selectedBackgroundImage') &&
      this.get('controller.selectedBackgroundImage') === this.get('pattern');
  }.property('controller.selectedBackgroundImage'),
  click: function(){
    arg = this.get('pattern');

    if ( this.get('controller.selectedBackgroundImage') === arg ) {
      arg = null;
    }

    this.get('controller').setProperties({
      selectedBackgroundImageStyle: "Pattern",
      selectedBackgroundImage: arg
    });
    return false;
  }
});

Pegasus.EmptySpacePatternView = Pegasus.PatternView.extend({
  classNames: ['empty-space'],
  style: '',
  pattern: '',
  patternSelected: function(){
    return ! this.get('controller.selectedBackgroundImage') ||
      this.get('controller.selectedBackgroundImage') &&
      this.get('controller.selectedBackgroundImage').match("background-patterns/space.gif");
  }.property('controller.selectedBackgroundImage'),
  click: function(){
    var arg = '';
    if ( this.get('pattern') ) {
      arg = Pegasus.get('templateAssetHost') + '/pegasus/assets/background-patterns/' + this.get('pattern') + '?' + Pegasus.version;
    }

    if ( this.get('controller.selectedBackgroundImage') === arg ) {
      arg = null;
    }

    this.get('controller').setProperties({
      selectedBackgroundImageCovers: false,
      selectedBackgroundImage: arg
    });

    return false;
  }
});

(function(){
  var templateColors = null;

  Pegasus.CustomBoxView = Ember.View.extend({
    template: Ember.Handlebars.compile('<input type="text" class="color-picker-region"></input>'),

    allowEmpty: false,

    title: function(){
      return Em.I18n.t('tips.select_custom');
    }.property(),
    attributeBindings: ['title'],

    onPickerChange: function(hex){
      var controller = Pegasus.lookupController('toolbar');
      controller.get('userSelectedColors').addObject(
        hex.toUpperCase()
      );
      this.$('.color-picker-region').spectrum('hide');
    },
    didInsertElement: function(){
      var self = this;

      var propertyName = this.get('elementId');
      //if another instance of it exists remove
      //this is kind of expensive. TODO investigate a better way
      $('.'+ propertyName +'.sp-container').remove();
      $('.'+ propertyName +' .sp-palette-container').remove();

      var view = this;
      var change = function(e) {
        if ( this.onPickerChange ) {
          this.onPickerChange(e.toHexString().toUpperCase());
        }
        if ( this.changeFunction ) {
          this.changeFunction(e.toHexString().toUpperCase());
        }
      }.bind(this);
      var hide = function(){
        $('body').off('click.spectrum');

        $('.vr-color-from-template').remove();
        $('.vr-recent-colors').remove();
        $('.editing-overlay').remove();
      };
      var show = function(){
        $('body').on('click.spectrum', function(){
          return false;
        });

        templateColors = templateColors || Pegasus.lookupController('toolbar').get('templateColors').slice(0);

        var userColors = Pegasus.lookupController('toolbar').get('userSelectedColors');
        userColors.forEach(function(color){
          templateColors.removeObject(color);
          templateColors.unshift(color);
        });

        var resultantColors = [];
        templateColors.forEach(function(color){
          if ( color ) {
            resultantColors.unshift(color);
          }
        });

        var recentColorItems = resultantColors.reverse().map(function(color){
          return '<div class="vr-recent-color" style="background:'+ color +';"></div>';
        });

        while ( recentColorItems.length < 5 ) {
          recentColorItems.push( '<div class="vr-recent-color empty"></div>' );
        }

        recentColorItems.length = 5;

        var translation = Em.I18n.t('g.recent_colors');
        var recentColors = $(
          '<div class="vr-recent-colors">' +
            '<label class="vr-recent-colors-label">'+translation+'</label>' +
            '<div class="vr-recent-color-selections">' +
              recentColorItems.join('') +
            '</div>' +
          '</div>'
        );

        translation = Em.I18n.t('g.color_from_template');

        var colorFromTemplateButton = $(
          '<div class="vr-color-from-template">' +
            '<button>'+translation+'</button>' +
          '</div>'
        );

        colorFromTemplateButton.on('click', function(){
          selectColorFromTemplate(self);
        });

        recentColors.find('.vr-recent-color:not(".empty")').off('click').on('click', function(){
          // close spectrum
          self.$('.color-picker-region').spectrum('hide');

          var str = $(this).css('backgroundColor');
          var rgb = str.replace(/rgb|\(|\)|\s/ig, '').split(',');
          if ( rgb.length > 0 ) {
            change({
              toHexString: function(){
                return Pegasus.Helpers.convertRgbToHex( rgb[0], rgb[1], rgb[2] );
              }
            });
            return;
          }

          change({
            toHexString: function(){
              return str;
            }
          });
        });

        $('.sp-top').before( colorFromTemplateButton );
        $('.sp-top').before( recentColors );
      };

      var chooseText = Em.I18n.t('g.choose');

      this.$('.color-picker-region').spectrum({
          color: this.get('initialBackground'),
          chooseText: chooseText,
          showInput: true,
          className: propertyName,
          showInitial: true,
          allowEmpty: this.get('allowEmpty'),
          showPaletteOnly: false,
          showSelectionPalette: true,
          maxPaletteSize: 10,
          preferredFormat: "hex",
          localStorageKey: "spectrum.demo",
          hide: hide,
          show: show,
          change: $.noop, // we control this out of band
          palette: [
              ["rgb(0, 0, 0)", "rgb(67, 67, 67)", "rgb(102, 102, 102)",
              "rgb(204, 204, 204)", "rgb(217, 217, 217)","rgb(255, 255, 255)"],
              ["rgb(152, 0, 0)", "rgb(255, 0, 0)", "rgb(255, 153, 0)", "rgb(255, 255, 0)", "rgb(0, 255, 0)",
              "rgb(0, 255, 255)", "rgb(74, 134, 232)", "rgb(0, 0, 255)", "rgb(153, 0, 255)", "rgb(255, 0, 255)"],
              ["rgb(230, 184, 175)", "rgb(244, 204, 204)", "rgb(252, 229, 205)", "rgb(255, 242, 204)", "rgb(217, 234, 211)",
              "rgb(208, 224, 227)", "rgb(201, 218, 248)", "rgb(207, 226, 243)", "rgb(217, 210, 233)", "rgb(234, 209, 220)",
              "rgb(221, 126, 107)", "rgb(234, 153, 153)", "rgb(249, 203, 156)", "rgb(255, 229, 153)", "rgb(182, 215, 168)",
              "rgb(162, 196, 201)", "rgb(164, 194, 244)", "rgb(159, 197, 232)", "rgb(180, 167, 214)", "rgb(213, 166, 189)",
              "rgb(204, 65, 37)", "rgb(224, 102, 102)", "rgb(246, 178, 107)", "rgb(255, 217, 102)", "rgb(147, 196, 125)",
              "rgb(118, 165, 175)", "rgb(109, 158, 235)", "rgb(111, 168, 220)", "rgb(142, 124, 195)", "rgb(194, 123, 160)",
              "rgb(166, 28, 0)", "rgb(204, 0, 0)", "rgb(230, 145, 56)", "rgb(241, 194, 50)", "rgb(106, 168, 79)",
              "rgb(69, 129, 142)", "rgb(60, 120, 216)", "rgb(61, 133, 198)", "rgb(103, 78, 167)", "rgb(166, 77, 121)",
              "rgb(91, 15, 0)", "rgb(102, 0, 0)", "rgb(120, 63, 4)", "rgb(127, 96, 0)", "rgb(39, 78, 19)",
              "rgb(12, 52, 61)", "rgb(28, 69, 135)", "rgb(7, 55, 99)", "rgb(32, 18, 77)", "rgb(76, 17, 48)"]
          ]
      });

      // We want `change` to be called everytime 'choose' is clicked
      $('.'+ propertyName +'.sp-container').find('.sp-choose').on('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        var val = $('.'+ propertyName +'.sp-container').find('.sp-input')[0].value;
        change({
          toHexString: function(){
            return val
          }
        });
      });

      $('.'+ propertyName +'.sp-container').find('.sp-input').click(function(){
        $(this).val('');
      });
    },
    willDestroyElement: function(){
      var propertyName = this.get('elementId');
      $('.'+ propertyName +'.sp-container').remove();
      $('.'+ propertyName+' .sp-palette-container').remove();

      this._super();
    },
    mouseUp: function(){
      Em.run.next(this, function(){
        var self = this;

        if ( $('.sp-container').not('.sp-hidden').length ) {
          var interactionBlocker = $('<div/>').addClass('editing-overlay');
          $(interactionBlocker).one('click', function(){
            self.$('.color-picker-region').spectrum('hide');
            return false;
          });
          interactionBlocker.appendTo('body');
        }
      });
    }
  });

  Pegasus.BackForeBase = Pegasus.CustomBoxView.extend({
    classNames: [
      'color-picker'
    ],
    title: function(){
      if ( !this.get('orientation') ) { return ''; }
      return Em.I18n.t( 'tips.' + this.get('orientation') + 'ground' );
    }.property('orientation'),

    orientation: null,
    onPickerChange: function(hex){
      this._super.apply(this, arguments);
      this.get('editorInstance').getSelection().selectRanges( this.get('storedRange') );
      CKEDITOR.tools.callFunction(53, hex,this.get('orientation'));
    },
    mouseEnter: function(){
      var instance = CKEDITOR.instances[ Object.keys(CKEDITOR.instances)[0] ];
      if ( instance ) {
        var selection = instance.getSelection();
        this.setProperties({
          storedRange: selection.getRanges(),
          editorInstance: instance
        });
      }
    },
    mouseLeave: function(){
      Em.run.cancel(this.tipTimer);
      this._super();
    },
    editorInstance: null,
    storedRange: null
  });

  Pegasus.CKForeColorPicker = Pegasus.BackForeBase.extend({
    orientation: 'fore'
  });

  Pegasus.CKBackColorPicker = Pegasus.BackForeBase.extend({
    orientation: 'back'
  });

})();

Pegasus.CustomColorBoxView = Pegasus.CustomBoxView.extend({
  color: function(){
    return this.get('property');
  }.property('property'),
  propertyName: 'primaryColor',
  colorSelected: null,
  initialBackground: function(){
    return this.get('property');
  }.property(),
  onPickerChange: function(hex){
    this._super.apply(this, arguments);
    this.get('controller').send('primaryColorDidChange', hex);
  }
});

Pegasus.BoundPropertyColorBoxView = Pegasus.CustomBoxView.extend({
  classNames: ['spectrum-color-picker'],
  placeholder: "#000000",
  template: function(){
    return Ember.Handlebars.compile('<input type="text" class="color-picker-region"></input>{{TextField fieldName="view.property" placeholder="' + this.get('placeholder') + '"}}');
  }.property('placeholder'),
  propertyName: null,
  propertyBinding: null,
  initialBackground: function(){
    return this.get('property');
  }.property('property'),
  onPickerChange: function(hex){
    this._super.apply(this, arguments);
    hex = hex.replace(/[^A-Fa-f0-9]/g, '').replace(/^/, '#');
    if ( hex.trim() === '#' ) {
      hex = '';
    }
    this.set('property', hex);
  },
  didInsertElement: function(){
    this._super();
    this.$('input').
      focus(function(){
        this.selectionStart = this.selectionEnd = this.value.length;
      }).
      off('keyup.' + this.get('elementId')).
      on('keyup.' + this.get('elementId'), function(e){
        if ( e.keyCode === 13 ) {
          this.onPickerChange( e.target.value );
          this.didBlur();
        }
      }.bind(this));
  },

  didBlur: function(e){},

  rerenderObserver: function(){
    if ( !this.$() ) { return; }
    var focused = !!( this.$('input:focus').length );
    Em.run.scheduleOnce('afterRender', this, 'rerender');
    if ( focused ) {
      Em.run.next(this, function(){
        this.$('input').focus();
      });
    }
  }.observes('property')
});

Pegasus.CustomBlockRegionColorBoxView = Pegasus.BoundPropertyColorBoxView.extend({
  clasNames: ['custom-theme-row'],
  property: null,
  onPickerChange: function(hex){
    var oldColor = this.get('controller.selectedBlockRegionColor');
    this.set('controller.selectedBlockRegionColor', hex);
    this._super.apply(this, arguments);
  },
  selectedColorObserver: function(){
    if ( !this.$() || !this.get('controller.selectedBlockRegionColor') ){
      return;
    }
    this.set('property', this.get('controller.selectedBlockRegionColor'));
  }.observes('controller.selectedBlockRegionColor'),
  init: function(){
    this._super();
    if ( !this.get('property') ) {
      this.set('property', this.get('controller.selectedBlockRegionColor'));
    }
  }
});

Pegasus.CustomFooterColorBoxView = Pegasus.BoundPropertyColorBoxView.extend({
  classNameBindings: ['invalidPicked:error'],
  property: null,
  willDestroyElement: function(){
    this.set('controller.desiredFooterLabelColor', this.get('controller.footerLabelColor'));
    this._super();
  },
  invalidPicked: false,
  selectedColorObserver: function(){
    this.set('invalidPicked', false);
    this.set('controller.desiredFooterLabelColor', this.get('controller.desiredFooterLabelColor').replace(/[^A-Fa-f0-9]/ig, '').replace(/^/, '#') );
    if ( this.get('controller.desiredFooterLabelColor').length !== 7 ) {
      return;
    }
    if ( colorsDistance( this.get('controller.selectedBackgroundColor'), this.get('controller.desiredFooterLabelColor') ) > 15 ) {
      this.get('controller').setProperties({
        footerLabelColor: this.get('controller.desiredFooterLabelColor')
      });
    } else {
      this.set('invalidPicked', true);
    }
  }.observes('controller.desiredFooterLabelColor')
});

Pegasus.CustomFooterAnchorColorBoxView = Pegasus.BoundPropertyColorBoxView.extend({
  classNameBindings: ['invalidPicked:error'],
  property: null,
  willDestroyElement: function(){
    this.set('controller.desiredFooterAnchorColor', this.get('controller.footerAnchorColor'));
    this._super();
  },
  invalidPicked: false,
  selectedColorObserver: function(){
    this.set('invalidPicked', false);
    this.set('controller.desiredFooterAnchorColor', this.get('controller.desiredFooterAnchorColor').replace(/[^A-Fa-f0-9]/ig, '').replace(/^/, '#') );
    if ( this.get('controller.desiredFooterAnchorColor').length !== 7 ) {
      return;
    }
    if ( colorsDistance( this.get('controller.selectedBackgroundColor'), this.get('controller.desiredFooterAnchorColor') ) > 15 ) {
      this.get('controller').setProperties({
        footerAnchorColor: this.get('controller.desiredFooterAnchorColor')
      });
    } else {
      this.set('invalidPicked', true);
    }
  }.observes('controller.desiredFooterAnchorColor')
});

Pegasus.CustomBackgroundColorBoxView = Pegasus.BoundPropertyColorBoxView.extend({
  property: null,
  classNameBindings: ['invalidPicked:error-body-color'],
  onPickerChange: function(hex){
    if ( !this.isValidSelection( hex ) ) {
      this.set('invalidPicked', true);
      return;
    }
    this.set('controller.selectedBackgroundColor', hex);
    this._super.apply(this, arguments);
  },
  invalidPicked: false,
  isValidSelection: function(hex){
    if ( hex === 'transparent' ) {
      hex = '#FFFFFF';
    }
    if ( ! this.get('controller.footerLabelColor') && ! this.get('controller.footerAnchorColor') ) { return true; }

    return colorsDistance( hex, this.get('controller.footerLabelColor') ) > 15 &&
      colorsDistance( hex, this.get('controller.footerAnchorColor') ) > 15;
  },
  selectedColorObserver: function(){
    var color = this.get('controller.selectedBackgroundColor');
    if ( !this.$() || !color ){
      return;
    }
    hex = color;
    if ( color.search(/^#/) > -1 ) {
      hex = color.replace(/[^A-Fa-f0-9]/ig, '').replace(/^/, '#');
    }
    this.set('invalidPicked', false);
    if ( !this.isValidSelection( hex ) ) {
      this.set('invalidPicked', true);
    }
    this.set('property', hex);
  }.observes('controller.selectedBackgroundColor'),

  didInsertElement: function(){
    this._super();
    this.$('input').
      focus(function(){
        this.selectionStart = this.selectionEnd = this.value.length;
      }).
      off('keyup.' + this.get('elementId')).
      on('keyup.' + this.get('elementId'), function(e){
        var hex = e.target.value.replace(/[^A-Fa-f0-9]/ig, '').replace(/^/, '#');
        e.target.value = hex;

        if ( hex.length !== 7 ) {
          return;
        }

        this.onPickerChange( hex );
        this.didBlur();
      }.bind(this));
  },

  init: function(){
    this._super();
    if ( !this.get('property') ) {
      this.set('property', this.get('controller.selectedBackgroundColor'));
    }
  }
});

Pegasus.CustomThemeRowColorBoxView = Pegasus.BoundPropertyColorBoxView.extend({
  propertyName: 'controller.selectedRowColor',
  property: function(){
    return this.get( this.get('propertyName') );
  }.property(),
  didInsertElement: function(){
    this._super();

    this.$('.ember-text-field').
      focus(function(){
        this.selectionStart = this.selectionEnd = this.value.length;
      }).
      off('keyup.' + this.get('elementId')).
      on('keyup.' + this.get('elementId'), function(e){
        this.onPickerChange( e.target.value );
        this.didBlur();
      }.bind(this));
  },
  onPickerChange: function(color){
    this._super.apply(this, arguments);
    this.set( this.get('propertyName'), this.get('property'));
    this.set('showColorReplacer', false);
  }
});

Pegasus.CustomRowColorBoxView = Pegasus.BoundPropertyColorBoxView.extend({
  propertyBinding: 'controller.dataRowColor',
  onPickerChange: function(hex){
    this.get('controller').setProperties({
      showColorPicker: false
    });
    this._super.apply(this, arguments);
    Em.run.scheduleOnce('afterRender', this.get('controller'), 'saveChange');
  },
  didInsertElement: function(){
    this._super();
    this.$('input').
      focus(function(){
        this.selectionStart = this.selectionEnd = this.value.length;
      }).
      off('keyup.' + this.get('elementId')).
      on('keyup.' + this.get('elementId'), function(e){
        if ( e.keyCode === 13 ) {
          this.onPickerChange( e.target.value );
          this.didBlur();
        }
      }.bind(this));
  }
});

Pegasus.ButtonBackgroundColorBoxView = Pegasus.CustomBoxView.extend({
  propertyName: 'buttonBackground',
  propertyBinding: 'controller.dataBackground',
  initialBackground: function(){
    return this.get('property');
  }.property(),
  onPickerChange: function(hex){
    this.set('property', hex);
    this._super.apply(this, arguments);
  }
});

Pegasus.ButtonBorderColorBoxView = Pegasus.CustomBoxView.extend({
  propertyName: 'buttonBorderColor',
  propertyBinding: 'controller.dataBorderColor',
  initialBackground: function(){
    return this.get('property');
  }.property(),
  onPickerChange: function(hex){
    this.set('property', hex);
    this._super.apply(this, arguments);
  }
});

Pegasus.ButtonTextColorBoxView = Pegasus.CustomBoxView.extend({
  propertyName: 'buttonColor',
  propertyBinding: 'controller.dataColor',
  initialBackground: function(){
    return this.get('property');
  }.property(),
  onPickerChange: function(hex){
    this.set('property', hex);
    this._super.apply(this, arguments);
  }
});

Pegasus.DividerColorBoxView = Pegasus.CustomBoxView.extend({
  propertyName: 'dividerBackground',
  propertyBinding: 'controller.dataBackground',
  initialBackground: function(){
    return this.get('property');
  }.property(),
  onPickerChange: function(hex){
    this.set('property', hex);
    this._super.apply(this, arguments);
  }
});
